<!--
 * @Author: your name
 * @Date: 2021-04-25 15:59:14
 * @LastEditTime: 2021-06-04 10:57:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \element\src\App.vue
-->
<template>
  <div id="app" class="container">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  updated() {},
  methods: {},
  created() {},
  mounted(){

}
}
</script>
<style lang="less">
@import url("./assets/comment.css");
.container {
  max-width: 750px;
  margin: 0 auto;
}
.el-alert__title {
  font-size: 20px !important;
  font-weight: bolder;
  line-height: 33px !important;
}
.el-tabs__item {
  font-size: 20px !important;
  font-weight: bolder !important;
}
.el-upload {
  border: 1px solid #ddd;
}
.el-collapse-item__header {
  font-size: 20px !important;
  font-weight: bold !important;
}
.upload-demo {
  margin: 20px 0;
}
.home {
  .el-tabs__nav {
    width: 100%;
    .el-tabs__item {
      width:25%;
      text-align: center;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-progress {
    margin: 10px 0;
  }
  .el-alert {
    margin: 10px 0;
  }

  .el-input,
  .el-select {
    margin-top: 0 !important;
  }
}
</style>
